import * as React from 'react'
import classNames from 'classnames'
import Link from 'next/link'
import { Button } from '../Button'
import { useQueryParam } from '../../hooks/useQueryParam'
import { formatPhoneNumber } from '../utils/string-utils'

type Props = {
  phoneNumber?: string
  className?: string
}

export const CitiesCTA: React.FC<Props> = ({ phoneNumber = '8558005629', className }) => {
  const query = useQueryParam()
  return (
    <div className={classNames('flex flex-col items-center', className)}>
      <div className="text-center w-full">
        <Link href={{ pathname: `/get-quote/`, query }}>
          <a>
            <Button className="w-full block sm:w-auto sm:inline py-2 px-6">GET A QUOTE</Button>
          </a>
        </Link>
      </div>
      <div className={'mt-3'}>
        Or call us at <a href={`tel:${phoneNumber}`}>{formatPhoneNumber(phoneNumber)}</a>
      </div>
    </div>
  )
}
